import { defaultMarkupAttributes, ShapesColors, ShapesDefaultNames, ShapesNames } from '../utils';
import { defaultTextAttributes } from '../utils';

export const MessageAttributes = {
  type: ShapesNames.MESSAGE_SHAPE,
  size: { width: 120, height: 40 },
  allowOrthogonalResize: false,
  defaultName: ShapesDefaultNames.MESSAGE_SHAPE,
  attrs: {
    body: {
      fill: '#FFFFFF',
      stroke: ShapesColors.MESSAGE_SHAPE,
      rx: 2,
      ry: 2,
      strokeWidth: 2
    },
    label: {
      ...defaultTextAttributes,
      textWrap: {
        text: ShapesDefaultNames.MESSAGE_SHAPE,
        width: -40,
        height: -10,
        ellipsis: '...'
      }
    },
    iconBackground: {
      width: 30,
      height: 40,
      fill: ShapesColors.MESSAGE_SHAPE,
      position: 'relative',
      x: 0,
      y: 1
    }
  },
  data: {
    name: ShapesDefaultNames.MESSAGE_SHAPE,
    contents: null
  },
  markup: defaultMarkupAttributes
};
